/* Naujienlaiskio pop-up rodymo salygos (Kasakai, 2026-09-11).

   Temos sekcija atidarydavo langa praejus 5 s nuo atvykimo - lankytojas dar
   nespedavo nei uzverti slapuku juostos, nei pamatyti, kur pateko. Clarity
   irasuose matyti, kaip zmones ji uzdaro nezvilgtereje i turini, o dalis kartu
   iseina is svetaines.

   Cia temos laikmatis parkuojamas (data-delay pakeliamas, o pats `open`
   uzdengiamas) ir langas atidaromas tik tada, kai lankytojas parodo
   susidomejima.

   2026-09-15 slenksciai pakelti mazdaug keturis kartus - Zydrunas pastebejo, kad
   langas vis tiek issoka per anksti. Buvusios reiksmes skliaustuose:
     - islieka svetaineje 3 min (buvo 45 s; laikas sumuojamas per visus puslapius);
     - arba perslenka 70 % puslapio ir islieka 75 s (buvo 50 % ir 15 s);
     - arba perziuri 3 skirtingas prekes (buvo 2), nuo 60 s (buvo 10 s);
     - arba darbastalyje veda pele link narsykles virsaus, bet ne anksciau kaip
       po 45 s (buvo 10 s).

   Niekada nerodoma: kol matoma slapuku juosta, kol atidarytas pokalbis ar kita
   temos uzsklanda, checkout'e ir paskyroje. Krepselio puslapyje - tik pries
   iseinant, kad nenutrauktume pirkimo. Paspaudus sonine "NEWSLETTER" kortele
   langas atsidaro iskart, kaip ir anksciau.

   Slapukas beyours:promo-popup (ji rasho pati tema, kai langas uzdaromas) cia
   gerbiamas: ji turintiems lankytojams skriptas nedaro nieko. */
(function () {
  var COOKIE = 'beyours:promo-popup';
  var SHOWN_KEY = 'kasakai:popup:shown';
  var TIME_KEY = 'kasakai:popup:time';
  var VIEWS_KEY = 'kasakai:popup:products';

  var SITE_MS = 180000;
  var SCROLL_MS = 75000;
  var SCROLL_RATIO = 0.7;
  var PRODUCTS_MS = 60000;
  var PRODUCTS_MIN = 3;
  var EXIT_MS = 45000;
  var TICK_MS = 1000;
  var PARKED_DELAY = '86400'; // 24 h - temos laikmatis nebesuveiks

  var path = window.location.pathname;
  var popup = document.querySelector('promo-popup');
  if (!popup) return;
  if (window.Shopify && window.Shopify.designMode) return; // temos redaktoriuje nesikisame
  if (popup.dataset.testMode === 'true') return;
  if (document.cookie.indexOf(COOKIE + '=') !== -1) return;
  if (/\/(checkouts?|account|challenge)(\/|$)/.test(path)) return;

  var allowed = false;
  var done = false;
  var cartOnly = /\/cart(\/|$)/.test(path); // krepselyje - tik exit-intent
  var maxScroll = 0;

  function session(key, fallback) {
    try {
      var raw = sessionStorage.getItem(key);
      return raw === null ? fallback : raw;
    } catch (error) {
      return fallback;
    }
  }

  function remember(key, value) {
    try {
      sessionStorage.setItem(key, value);
    } catch (error) {
      /* privatus rezimas - tiesiog neprisimename */
    }
  }

  if (session(SHOWN_KEY, '') === '1') return;

  var elapsed = parseInt(session(TIME_KEY, '0'), 10) || 0;

  // Perziuretos prekes - sumuojame per visa apsilankyma, be pasikartojimu.
  var products = [];
  try {
    products = JSON.parse(session(VIEWS_KEY, '[]')) || [];
  } catch (error) {
    products = [];
  }
  var productMatch = path.match(/\/products\/([^/?#]+)/);
  if (productMatch && products.indexOf(productMatch[1]) === -1) {
    products.push(productMatch[1]);
    remember(VIEWS_KEY, JSON.stringify(products.slice(-10)));
  }

  // Temos laikmatis parkuojamas dar pries popup.js - tas skriptas kraunamas
  // veliau dokumente, tad si eilute suspeja pirma.
  popup.dataset.delay = PARKED_DELAY;

  // ... ir tam atvejui, jei kada pasikeistu skriptu eile, uzdengiame ir pati
  // atidaryma: kol neleista, `open()` nieko nedaro.
  window.customElements.whenDefined('promo-popup').then(function () {
    var inherited = Object.getPrototypeOf(popup).open;
    if (typeof inherited !== 'function') return;
    popup.open = function () {
      if (!allowed) return;
      inherited.call(popup);
    };
  });

  // Rankinis atidarymas (sonine "NEWSLETTER" kortele) lieka kaip buves.
  document.addEventListener(
    'click',
    function (event) {
      if (event.target && event.target.closest && event.target.closest('[data-popup-toggle]')) {
        allowed = true;
      }
    },
    true
  );

  // Matomumas tikrinamas per dydi ir stiliu, o ne per offsetParent: slapuku
  // juosta yra position:fixed, o tokiems elementams offsetParent visada null.
  function visible(node) {
    if (!node) return false;
    var style = window.getComputedStyle(node);
    if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') {
      return false;
    }
    var rect = node.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  /* Kada rodyti negalima: lankytojas jau turi ka spresti ekrane. */
  function busy() {
    var consent = document.querySelectorAll(
      '#shopify-pc__banner, .shopify-pc__banner, cookie-banner, .cookie-banner'
    );
    for (var i = 0; i < consent.length; i++) {
      if (visible(consent[i])) return true;
    }
    if (document.body.classList.contains('promo-popup--open')) return true;
    if (document.querySelector('.drawer.is-active, cart-drawer.is-active, .modal.is-active')) {
      return true;
    }
    var chat = document.getElementById('smartchat-host');
    if (chat && chat.shadowRoot && chat.shadowRoot.querySelector('.sc-panel')) return true;
    return false;
  }

  function show() {
    if (done || busy()) return;
    done = true;
    allowed = true;
    remember(SHOWN_KEY, '1');
    popup.open();
  }

  var timer = window.setInterval(function () {
    if (done) {
      window.clearInterval(timer);
      return;
    }
    if (document.visibilityState !== 'visible') return;
    elapsed += TICK_MS;
    remember(TIME_KEY, String(elapsed));
    if (cartOnly) return;

    var ratio = 0;
    var docHeight = document.documentElement.scrollHeight;
    if (docHeight > window.innerHeight) {
      ratio = (window.scrollY + window.innerHeight) / docHeight;
      if (ratio > maxScroll) maxScroll = ratio;
    }

    if (elapsed >= SITE_MS) show();
    else if (elapsed >= SCROLL_MS && maxScroll >= SCROLL_RATIO) show();
    else if (elapsed >= PRODUCTS_MS && products.length >= PRODUCTS_MIN) show();
  }, TICK_MS);

  // Ruosiasi iseiti: pele kyla virs narsykles lango. Tik su tikra pele -
  // telefone tokio signalo nera, ten pakanka laiko ir slinkimo taisykliu.
  if (window.matchMedia('(pointer: fine)').matches) {
    document.addEventListener('mouseout', function (event) {
      if (event.relatedTarget || event.clientY > 0) return;
      if (elapsed < EXIT_MS) return;
      show();
    });
  }
})();
